import { useAuth, useAuthActions } from "@frontegg/react";
import { useEffect } from "react";

import { REFRESH_BUFFER_SEC } from "./TokenRefreshOnVisibility.consts";

// Backgrounded tabs miss Frontegg's keepSessionAlive (which relies on user activity),
// so we proactively refresh when the tab returns and the token is near expiry.
const TokenRefreshOnVisibility = () => {
  const { requestAuthorize } = useAuthActions();
  const { user } = useAuth();
  const exp = user?.exp;

  useEffect(() => {
    if (!exp) return undefined;
    let refreshing = false;

    const onVisibilityChange = async () => {
      if (refreshing || document.visibilityState !== "visible") return;
      const secondsLeft = exp - Math.floor(Date.now() / 1000);
      if (secondsLeft >= REFRESH_BUFFER_SEC) return;
      refreshing = true;
      try {
        await requestAuthorize(false);
      } finally {
        refreshing = false;
      }
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  }, [exp, requestAuthorize]);

  return null;
};

export default TokenRefreshOnVisibility;
